import React, { useState } from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from './Menu';

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ backgroundColor: 'rgba(15, 23, 42, 0.85)', backdropFilter: 'blur(10px)', borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ mx: 'auto', pr: 6, textAlign: 'center', lineHeight: 1.3, py: 1 }}>
            <Box component="span" sx={{ display: 'inline-block' }}>ティンクルスターナイツ</Box>
            <Box component="span" sx={{ display: 'inline-block', ml: { xs: 0, sm: 0.5 } }}>ライブラリ</Box>
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Menu open={open} onClose={() => setOpen(false)} />
    </>
  );
}
